import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Cotizacion } from '../Cotizacion/models/cotizacion';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CotizacionesService {
  // Conectado al puerto estándar de tu controlador de cotizaciones comerciales
  private apiUrl = '/api/v1/cotizaciones';

  constructor(private http: HttpClient) {}

  getAll(): Observable<Cotizacion[]> {
    return this.http.get<Cotizacion[]>(this.apiUrl);
  }

  getById(id: number): Observable<Cotizacion> {
    return this.http.get<Cotizacion>(`${this.apiUrl}/${id}`);
  }

  getByCustomer(an8: number): Observable<Cotizacion[]> {
    return this.http.get<Cotizacion[]>(`${this.apiUrl}/customer/${an8}`);
  }

  save(cotizacion: Cotizacion): Observable<Cotizacion> {
    return this.http.post<Cotizacion>(this.apiUrl, cotizacion);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }

  // 🚀 Enlace remoto asíncrono para el Webhook del Correo electrónico del Cliente
  public procesarAprobacionRemota(token: string, accion: 'APROBAR' | 'RECHAZAR', comentarios: string, lineas: any[]): Observable<any> {
    console.log(`📡 [SaaS Móvil] Enviando veredicto del cliente en red. Acción: ${accion}`);
    // Consumimos el endpoint público desacoplado
    return this.http.post(`/api/v1/publico/remoto/procesar`, {
      token,
      accion,
      comentarios,
      lineas // Inyectamos la matriz de checkboxes interactivos
    });
  }

  public obtenerPresupuestoPublicoPorToken(tokenSha256: string): Observable<Cotizacion> {
    console.log('📡 [SaaS Network] Consumiendo canal público unificado para token:', tokenSha256);
    return this.http.get<Cotizacion>(`/api/v1/publico/remoto/token/${tokenSha256}`);
  }

}